<template>
  <myDialog :isDialog="isDialog" :title="isEdit ? '编辑服务站点' : '新增服务站点'" :width="'800px'" @handleClose="handleClose">
    <template slot="content">
      <el-form :model="formData" :rules="rules" ref="form" label-width="140px">
        <!-- 站点类型 -->
        <el-form-item label="站点类型" prop="type">
          <el-select v-model="formData.type" placeholder="请选择站点类型" style="width: 100%;">
            <el-option 
              v-for="item in stationTypeList" 
              :key="item.dictValue" 
              :label="item.dictLabel" 
              :value="item.dictValue">
            </el-option>
          </el-select>
        </el-form-item>

        <!-- 名称 -->
        <el-form-item label="名称" prop="name">
          <el-input v-model="formData.name" placeholder="请输入名称" maxlength="100" show-word-limit></el-input>
        </el-form-item>

        <!-- 所属街镇 -->
        <el-form-item label="所属街镇" prop="streetTown">
          <el-input v-model="formData.streetTown" placeholder="请输入所属街镇" maxlength="100"></el-input>
        </el-form-item>

        <!-- 详细地址 -->
        <el-form-item label="详细地址" prop="address">
          <el-input v-model="formData.address" placeholder="请输入详细地址" maxlength="200" show-word-limit></el-input>
        </el-form-item>

        <!-- 联系电话 -->
        <el-form-item label="联系电话" prop="phone">
          <el-input v-model="formData.phone" placeholder="请输入联系电话" maxlength="20"></el-input>
        </el-form-item>

        <!-- 简介 -->
        <el-form-item label="简介" prop="description">
          <el-input 
            type="textarea" 
            v-model="formData.description" 
            placeholder="请输入简介" 
            maxlength="500" 
            show-word-limit
            :rows="4"
          ></el-input>
        </el-form-item>

        <!-- 主要服务 -->
        <el-form-item label="主要服务" prop="mainServices" v-if="formData.type ==1 || formData.type ==2">
          <el-input 
            type="textarea" 
            v-model="formData.mainServices" 
            placeholder="请输入主要服务" 
            maxlength="500" 
            show-word-limit
            :rows="4"
          ></el-input>
        </el-form-item>

        <!-- 主要培训工种 -->
        <el-form-item label="主要培训工种" prop="mainCourses" v-if="formData.type ==3">
          <el-input v-model="formData.mainCourses" placeholder="请输入主要培训工种" maxlength="200" show-word-limit></el-input>
        </el-form-item>

        <!-- 开放时间 -->
        <el-form-item label="开放时间" prop="openTime" v-if="formData.type ==1 || formData.type ==2">
          <el-input v-model="formData.openTime" placeholder="请输入开放时间，如：周一至周五 09:00-17:00" maxlength="-1"></el-input>
        </el-form-item>
      </el-form>
    </template>
    <template slot="footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="loading">保存</el-button>
    </template>
  </myDialog>
</template>

<script>
import { addServiceSite, updateServiceSite } from '@/api/mapServer/serviceSite'
import { getListByDictType } from '@/api/sys/dictData'

export default {
  name: 'ServiceSiteDialog',
  props: {
    isDialog: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    editData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      stationTypeList: [],
      formData: {
        type: '',
        name: '',
        streetTown: '',
        address: '',
        phone: '',
        description: '',
        mainServices: '',
        mainCourses: '',
        openTime: ''
      },
      loading: false,
      rules: {
        type: [
          { required: true, message: '请选择站点类型', trigger: 'change' }
        ],
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' }
        ],
        streetTown: [
          { required: true, message: '请输入所属街镇', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '请输入详细地址', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' }
        ],
        description: [
          { required: true, message: '请输入简介', trigger: 'blur' }
        ],
        mainServices: [
          { required: true, message: '请输入主要服务', trigger: 'blur' }
        ],
        mainCourses: [
          { required: true, message: '请输入主要培训工种', trigger: 'blur' }
        ],
        openTime: [
          { required: true, message: '请输入开放时间', trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    editData: {
      handler(newVal) {
        if (newVal && this.isEdit && Object.keys(newVal).length > 0) {
          this.formData = {
            id: newVal.id,
            type: String(newVal.type) || '',
            name: newVal.name || '',
            streetTown: newVal.streetTown || '',
            address: newVal.address || '',
            phone: newVal.phone || '',
            description: newVal.description || '',
            mainServices: newVal.mainServices || '',
            mainCourses: newVal.mainCourses || '',
            openTime: newVal.openTime || ''
          }
        }
      },
      immediate: true,
      deep: true
    },
    isDialog(val) {
      if (!val) {
        this.resetForm()
      }
    }
  },
  mounted() {
    this.loadStationType()
  },
  methods: {
    async loadStationType() {
      const res = await getListByDictType('station_type')
      if (res && res.code === 200 && res.data) {
        this.stationTypeList = res.data
      }
    },
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true

          const submitData = { ...this.formData }

          const api = this.isEdit ? updateServiceSite : addServiceSite
          api(submitData).then(res => {
            if (res && res.code === 200) {
              this.$message.success(this.isEdit ? '编辑成功' : '新增成功')
              this.$emit('success')
              this.handleClose()
            } else {
              this.$message.error(res.msg || '操作失败')
            }
          }).catch(err => {
            console.error('请求出错', err)
            this.$message.error('操作失败')
          }).finally(() => {
            this.loading = false
          })
        }
      })
    },
    handleClose() {
      this.$emit('handleClose')
      this.resetForm()
    },
    resetForm() {
      this.$refs.form && this.$refs.form.resetFields()
      this.formData = {
        type: '',
        name: '',
        streetTown: '',
        address: '',
        phone: '',
        description: '',
        mainServices: '',
        mainCourses: '',
        openTime: ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-form-item__label {
    color: #2A3347 !important;
    font-weight: 400;
    font-size: 16px;
}

/deep/ .el-dialog__header {
    background: #297DEE !important;
}

/deep/ .el-dialog__title {
    color: #ffffff !important;
    font-weight: 700;
    font-size: 17px;
}

/deep/ .el-dialog__headerbtn {
  filter: brightness(0) invert(1) !important;
}
</style>
